var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoinOne = function SvgCoinOne(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#5656FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.04297 11.5305L11.048 18.6291V22.5109H13.3535V18.6291L17.3585 11.5305H14.7582L12.2544 16.2593H12.1471L9.6433 11.5305H7.04297Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5831 14.6884H26.8082C26.776 12.7315 25.1675 11.3804 22.7227 11.3804C20.3154 11.3804 18.5514 12.71 18.5622 14.7045C18.5568 16.3237 19.6988 17.2512 21.5539 17.6962L22.7495 17.9965C23.9451 18.286 24.6099 18.6291 24.6153 19.369C24.6099 20.1732 23.8486 20.7201 22.6691 20.7201C21.4627 20.7201 20.5942 20.1625 20.5191 19.0634H18.2726C18.3316 21.4386 20.0312 22.6663 22.6959 22.6663C25.3766 22.6663 26.9529 21.3849 26.9583 19.3744C26.9529 17.5461 25.575 16.5757 23.6663 16.1468L22.6798 15.9108C21.7255 15.691 20.9266 15.3372 20.9427 14.549C20.9427 13.8413 21.57 13.3212 22.7066 13.3212C23.8164 13.3212 24.4974 13.8252 24.5831 14.6884Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoinOne, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coinOne.3d3ae44d.svg";
export { ForwardRef as ReactComponent };